import { render, staticRenderFns } from "./UserHistoryList.vue?vue&type=template&id=b06d30ba&"
import script from "./UserHistoryList.vue?vue&type=script&lang=ts&"
export * from "./UserHistoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports